import { render, staticRenderFns } from "./MemberImport.vue?vue&type=template&id=130f3d90&scoped=true&"
import script from "./MemberImport.vue?vue&type=script&lang=js&"
export * from "./MemberImport.vue?vue&type=script&lang=js&"
import style0 from "./MemberImport.vue?vue&type=style&index=0&id=130f3d90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130f3d90",
  null
  
)

export default component.exports